import React, { useState, useEffect, useCallback } from "react";
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './MaterialList.css';
import usePageMetadata from '../../hooks/usePageMetadata';
import { getMaterials, searchMaterials } from '../../services/materialService';
import { getMaterialComparisonUrl } from './materialTools';

const MaterialList = () => {
    const [materials, setMaterials] = useState([]);
    const [page, setPage] = useState(1);
    const [searchString, setSearchString] = useState('');
    const limit = 8;
    const pageTitle = 'Engineering Materials for CNC Machining | ASiJoLab';
    const pageDescription = 'Browse verified engineering material records and practical property information for CNC machining.';

    usePageMetadata(pageTitle, pageDescription);

    const loadMaterials = useCallback(async () => {
        try {
            const materials = searchString
                ? await searchMaterials({ page, limit, searchString })
                : await getMaterials({ page, limit });
            setMaterials(materials);
        } catch (error) {
            console.error('Error fetching materials:', error);
            setMaterials([]);
        }
    }, [page, searchString]);

    useEffect(() => {
        loadMaterials();
    }, [loadMaterials]);

    const handleNextPage = (e) => {
        e.preventDefault();
        setPage(prevPage => prevPage + 1);
    };

    const handlePrevPage = (e) => {
        e.preventDefault();
        setPage(prevPage => Math.max(prevPage - 1, 1));
    };

    const handleSearchChange = (e) => {
        const input = e.target.value;
        setSearchString(input);
        setPage(1);
    };

    return (
        <div>
                <header className="material-list-intro">
                    <h1>Engineering materials for CNC machining</h1>
                    <p>
                        Browse verified material records and open a material to
                        review available properties and machining context.
                    </p>
                </header>
                <div className="search-container">
                    <label htmlFor="material-search">Search materials</label>
                    <input
                        id="material-search"
                        type="text"
                        placeholder="Search your material..."
                        value={searchString}
                        onChange={handleSearchChange}
                    />
                </div>
            <div className="materials-container">
                {materials.map((material) => (
                        <article key={material._id} className="material-item">
                            <Link className="material-item-primary" to={`/materials/${encodeURIComponent(material.slug)}`}>
                                <h2>{material.name}</h2>
                                <h3>{material.materialName}</h3>
                                <div className="other-names">
                                    {(material.otherNames || []).map((name, index) => <div key={index}>{name}</div>)}
                                </div>
                            </Link>
                            <div className="material-item-actions">
                                <Link to={getMaterialComparisonUrl('materialA', material.slug)}>Compare</Link>
                            </div>
                        </article>
                    ))}
            </div>
                <div className="lists-buttons">
                    <button onClick={handlePrevPage} disabled={page === 1}>Previous</button>
                    <button onClick={handleNextPage}>Next</button>
                </div>
        </div>
    );
};

export default MaterialList;
